export const environment = {
  production: true,
  api_base: 'https://api-new.autotaxatiepartners.nl',
  application: 'atp-expertteam',
  password: 'N2J4wi9XRX66rokWHYLG',
  // First item will be the default, one entry will hide the field.
  level: ['person']
};
